import EditIcon from './EditIcon';

export default EditIcon;



// WEBPACK FOOTER //
// ./src/components/EditIcon/index.ts